"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _collapseContext = require("./collapse-context");

var _useCurrentState = _interopRequireDefault(require("../use-current-state"));

var _useTheme = _interopRequireDefault(require("../use-theme"));

var _collections = require("../utils/collections");

var _collapse = require("./collapse.styles");

var _collapse2 = _interopRequireDefault(require("./collapse"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const defaultProps = {
  accordion: true
};

const CollapseGroup = ({
  children,
  accordion,
  animated,
  divider,
  onChange,
  ...props
}) => {
  const [state, setState, stateRef] = (0, _useCurrentState.default)([]);
  const {
    isDark
  } = (0, _useTheme.default)();

  const updateValues = (currentIndex, nextState) => {
    const hasChild = stateRef.current.find(val => val === currentIndex);
    onChange && onChange(currentIndex, nextState);

    if (accordion) {
      if (nextState) return setState([currentIndex]);
      return setState([]);
    }

    if (nextState) {
      // In a few cases, the user will set Collapse Component state manually.
      // If the user incorrectly set the state, Group component should ignore it.

      /* istanbul ignore if */
      if (hasChild) return;
      return setState([...stateRef.current, currentIndex]);
    }

    setState(stateRef.current.filter(item => item !== currentIndex));
  };

  const initialValue = (0, _react.useMemo)(() => ({
    values: state,
    updateValues,
    divider,
    animated
  }), [state.join(',')]);
  const hasIndexChildren = (0, _react.useMemo)(() => (0, _collections.setChildrenIndex)(children, [_collapse2.default]), [children]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_collapseContext.CollapseContext.Provider, {
    value: initialValue,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_collapse.StyledCollapseGroup, {
      isDark: isDark,
      ...props,
      children: hasIndexChildren
    })
  });
};

CollapseGroup.toString = () => '.nextui-collapse-group';

var _default = (0, _withDefaults.default)(CollapseGroup, defaultProps);

exports.default = _default;
module.exports = exports.default;